import { forwardRef } from "react";

import { Icon, IconProps } from "../icon";

export type ChattingSolidIconProps = IconProps;

export const ChattingSolidIcon = forwardRef<
  SVGSVGElement,
  ChattingSolidIconProps
>(function ChattingSolidIcon(props: ChattingSolidIconProps, ref) {
  return (
    <Icon
      data-testid="ChattingSolidIcon"
      aria-label="chatting solid"
      viewBox="0 0 12 12"
      ref={ref}
      {...props}
    >
      <path d="M5.657 0C2.533 0 0 2.587 0 5.778s2.533 5.778 5.657 5.778a5.547 5.547 0 0 0 2.958-.852L12 12.001l-1.313-3.577c.4-.793.626-1.692.626-2.646C11.313 2.587 8.78 0 5.656 0zm.88 5.906c0 .567-.45 1.027-1.006 1.027s-1.006-.46-1.006-1.027.45-1.027 1.006-1.027 1.006.46 1.006 1.027zm2.765 0c0 .567-.45 1.027-1.006 1.027S7.29 6.473 7.29 5.906s.45-1.027 1.006-1.027 1.006.46 1.006 1.027zm-5.531 0c0 .567-.45 1.027-1.006 1.027s-1.006-.46-1.006-1.027.45-1.027 1.006-1.027 1.006.46 1.006 1.027z" />
    </Icon>
  );
});
